import React, { useCallback, useEffect, useState } from "react";
import { Popup } from "semantic-ui-react";
import "./Bookmark.css";
import { IoChevronForwardOutline } from "react-icons/io5";
import Select from "react-select";
import axios from "../../../../axios";
import ResolveQueryLib from "./resolveQueryLib";
import Query from "./query";
import { iconData } from "../../../../iconData";
import GeneralErrorMessages from "./generalErrorMessages";
import NoGroupPresentPopup from "./NoGroupPresentPopup";
import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import assets from "../../../../assets/assets";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function QueryResonse({
  userData,
  book,
  chapter,
  chapterName,
  bookName,
  grpId,
  componentRerenderFlag,
  setComponentRerenderFlag,
  clickedSubjectId,
}) {
  const [editQuery, setEditQuery] = useState();
  const [queryTopicList, setQueryTopicList] = useState([]);
  const [clickedTopic, setClickedTopic] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [groupId, setGroupId] = useState("");
  const [notesAttachmentUrl, setNotesAttachmentUrl] = useState([]);
  const [notesAttachment, setNotesAttachment] = useState([]);
  const [tagLimit, setTagLimit] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [attachMent2, setAttachment2] = useState([]);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [didErrorOccur, setDidErrorOccur] = useState(false);
  const [errorMessage, setErrorMessage] = useState(" ");
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [groupNotPresentPopUp, setGroupNotPresentPopUp] = useState(false);
  let data = JSON.parse(localStorage.getItem("breathForStudent"));

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.pptx|\.ppt|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  useEffect(() => {
    setTitle(editQuery?.query);
    setClickedTopic(editQuery?.tags);
    setDescription(editQuery?.description);
    if (editQuery?.attachments) {
      const attachmentData = editQuery?.attachments?.flatMap(
        (attachment) => attachment,
      );
      setNotesAttachment(attachmentData);
      setNotesAttachmentUrl(attachmentData);
    }
  }, [editQuery]);
  useEffect(() => {
    const getTags = async () => {
      try {
        let tags = await axios.get(`/query/tags/get`);
        let tagList = tags?.data?.data?.map((tag) => {
          return { label: tag, value: tag };
        });
        tagList.length > 0 && setQueryTopicList(tagList);
      } catch (error) {
        console.log(error);
      }
    };
    getTags();
    // let grpId = localStorage.getItem("GroupId");
    // setGroupId(grpId);
  }, []);

  useEffect(() => {
    async function getGroup() {
      setIsLoading(true);
      try {
        // 🔥 Debug logs for full visibility
        console.log("🔍 GET GROUP: Params Check", {
          studentId: data?.id,
          standardId: data?.standard?.id,
          sectionId: data?.section?.id,
          subjectId: clickedSubjectId,
        });

        // 🔥 URL log before request
        let url = clickedSubjectId
          ? `/group/filterForStudent/studentId/${data?.id}?standardId=${data?.standard?.id}&sectionId=${data?.section?.id}&subjectId=${clickedSubjectId}`
          : `/group/filterForStudent/studentId/${data?.id}`;

        const res = await axios.get(url);

        if (res.data.data && res.data.data.length > 0) {
          setGroupId(res.data.data[0].id);
        } else {
          console.log("⚠️ No group found for this subject");
        }
      } catch (error) {
        console.error("❌ Error fetching group data:", error);
      } finally {
        setIsLoading(false);
      }
    }

    if (data?.id) {
      getGroup();
    }
  }, [clickedSubjectId]);

  const handleInputChange = useCallback(
    debounce((inputValue) => {
      if (inputValue.length > 20) {
        inputValue = inputValue.substring(0, 20);
        setTagLimit(true);
      } else {
        setTagLimit(false);
      }
      setQueryTopicList((prev) => [
        ...prev,
        { value: inputValue, label: inputValue },
      ]);
    }, 900),
    [],
  );
  const [notesAttachmentId, setNotesAttachmentId] = useState([]);

  const buttonDisable = () => {
    if (clickedTopic?.length > 0 && title !== "" && description !== "") {
      return false;
    } else {
      return true;
    }
  };
  const handleAttachment = async (files) => {
    let attachments = [...notesAttachment];
    let attachmentId = [...notesAttachmentId];
    let attachmentUrl = [...notesAttachmentUrl];
    let totalSizeInBytes = attachMent2.reduce(
      (acc, file) => acc + file.size,
      0,
    );
    let fileCount = attachMent2.length;
    if (files) {
      for (const file of files) {
        try {
          // Check if the file is already uploaded
          const isFileAlreadyUploaded = attachMent2.some(
            (uploadedFile) =>
              uploadedFile.name === file.name &&
              uploadedFile.size === file.size,
          );

          if (isFileAlreadyUploaded) {
            console.log("File already uploaded");
            setIsValidFileType(false);
            return;
          }
          if (
            fileCount < 5 &&
            totalSizeInBytes + file.size <= 10 * 1024 * 1024 &&
            validateFileType(file)
          ) {
            let formData = new FormData();
            // formData.append("name", file.name);
            formData.append("uploadQueryAttachment", file);
            let res = await axios.post(
              `/query/uploadAttachment/userId/${userData.id}`,
              formData,
            );
            res && attachments.push(res.data);
            res && attachmentUrl.push(res.data.data);
            setAttachment2((prev) => [...prev, file]);
          } else {
            setIsValidFileType(false);
          }
        } catch (error) {
          setDidErrorOccur(true);
          setErrorMessage(error.response.data.message);
          console.log(error);
        }
      }
      if (attachments.length > 0) {
        setNotesAttachment(attachments);
        setNotesAttachmentId(attachmentId);
        setNotesAttachmentUrl(attachmentUrl);
      }
    }
  };
  const handleremove = (indexToRemove) => {
    if (indexToRemove >= 0 && indexToRemove < notesAttachment.length) {
      const updatedAttachments = [...notesAttachment];
      const updatedAttachments1 = [...notesAttachmentId];
      const updatedAttachments2 = [...notesAttachmentUrl];
      if (attachMent2 && attachMent2.length > 0) {
        const newArrayLimit = [...attachMent2];
        newArrayLimit.splice(indexToRemove, 1);
        setAttachment2(newArrayLimit);
      }
      updatedAttachments.splice(indexToRemove, 1);
      updatedAttachments1.splice(indexToRemove, 1);
      updatedAttachments2.splice(indexToRemove, 1);
      setNotesAttachment(updatedAttachments);
      setNotesAttachmentId(updatedAttachments1);
      setNotesAttachmentUrl(updatedAttachments2);
    }
  };
  const handleQueryCreation = async () => {
    setIsLoading(true);
    try {
      let body = {
        user_id: userData.id,
        query: title,
        tags: clickedTopic,
        group_id: groupId,
        book_id: book.id,
        chapter_id: chapter,
        description: description,
        attachments: notesAttachmentUrl,
        status: "pending",
      };
      if (!groupId) {
        setGroupNotPresentPopUp(true);
        return;
      }
      if (isUpdate) {
        let res = await axios.put(`/query/update/${editQuery?.id}`, body);
        if (res.data.message === "Updated successfully.") {
          // window.location.reload();
          setComponentRerenderFlag((prevFlag) => !prevFlag);
          setNotesAttachment([]);
          setNotesAttachmentId([]);
          setNotesAttachmentUrl([]);
          setAttachment2([]);
          setClickedTopic([]);
          // setQueryTopicList([]);
          setDescription("");
          setTitle("");
        }

        setIsUpdate(false);
      } else {
        if (!groupId) {
          setGroupNotPresentPopUp(true);
          return;
        }
        let res = await axios.post(`/query/create/groupId/${groupId}`, body);
        if (res.status === 201) {
          // window.location.reload();
          setComponentRerenderFlag((prevFlag) => !prevFlag);
          setNotesAttachment([]);
          setNotesAttachmentId([]);
          setNotesAttachmentUrl([]);
          setAttachment2([]);
          setClickedTopic([]);
          // setQueryTopicList([]);
          setDescription("");
          setTitle("");
        }
      }
    } catch (error) {
      console.log(error);
      setDidErrorOccur(true);
      setErrorMessage(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };
  const [markQuery, setMarkQuery] = useState();
  const [clickedQuery, setClickedQuery] = useState();
  return (
    <div>
      {/* <div className="TotalQuerResponseConatiner p-3 mt-3">
        {tagLimit && (
          <p className="SpclStyle">
            Tag length exceeded, please enter a tag less than 20 Characters.
          </p>
        )}
        <div className="d-flex gap-4 ">
          <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "none",
                borderBottom: "1px solid #000",
                borderRadius: 0,
                boxShadow: "none",
              }),
              indicatorSeparator: () => ({
                display: "none",
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#99ADBB",
              }),
              indicatorsContainer: (provided, state) => ({
                ...provided,
                display: "none",
              }),
            }}
            placeholder="⊕  Add Tags"
            className="addTagsQuery"
            options={clickedTopic?.length >= 3 ? [] : queryTopicList}
            isMulti
            isSearchable={true}
           
            value={queryTopicList?.filter((option) =>
              clickedTopic?.includes(option?.value)
            )}
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map(
                (option) => option.value
              );
              setClickedTopic(selectedValues);
            }}
            onInputChange={(e) => handleInputChange(e)}
          />
          <button
          
            className={title ? "postqerybtn" : "postqerybtnDisable"}
            disabled={!title}
            onClick={() => {
              handleQueryCreation();
            }}
          >
            {isUpdate ? "Update" : "Post"} Query
          </button>
        </div>
        <div className="mt-3">
          <input
            placeholder="Add Title"
            className="addTitle"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            maxLength={150}
          ></input>
        </div>
        <div className="TypeMsgContainer mt-3 d-flex align-items-center gap-3">
          <input
            placeholder="Type message"
            className="TypeMsgInput"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            maxLength={500}
          ></input>

          <div className="mr-2 pt-1">
            <input
              onChange={(e) => {
                handleAttachment(e.target.files);
                e.target.value = null;
              }}
              multiple
              type="file"
              id="attachFile"
              accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
              style={{ display: "none" }}
            />
            <label htmlFor="attachFile">
              <img
                style={{ cursor: "pointer" }}
                src={assets.UploadIcon}
                className="w-7"
                alt="Attachment icon"
              />
            </label>
          </div>
        </div>
        {!isValidFileType && (
          <p id="errorMsg">
            "Exceeded Limit !! Max 5 attachments and total of 10 MB size is
            allowed."
          </p>
        )}
        <div className="overflow">
          <div className="d-flex gap-4 justify-content-end mt-3 overflow">
            {notesAttachmentUrl?.length > 0 &&
              notesAttachmentUrl?.map((obj, index) => (
                <div className="d-flex gap-2 align-items-center">
                  <div>
                    <img
                      src={`${
                        iconData?.find(
                          (i) => i.extension === obj?.split(".")[1]
                        )?.icon
                      }`}
                      alt=""
                      style={{ width: "20px", height: "20px" }}
                    />
                  </div>
                  <div className="UplodedimgName" title={obj}>
                    <div className="UplodedimgName" title={obj}>
                      {obj?.indexOf("_") > 0
                        ? obj.substring(
                            obj.indexOf("_") + 1,
                            obj.indexOf("_") + 13
                          ) + "..."
                        : obj.length > 15
                        ? obj.substring(0, 12) + "..."
                        : obj}
                    </div>
                  </div>
                  <div className="ml-2">
                    <img
                      src="/LibraryImg/CrossPdf.png"
                      alt=""
                      onClick={() => {
                        handleremove(index);
                      }}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div> */}

      <div className="flex justify-end items-center m-2">
        {/* <h5 className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-400 bg-clip-text text-transparent tracking-tight">
          Your Queries
        </h5> */}

        <Button
          variant="contained"
          onClick={() => setOpenQueryDialog(true)}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            paddingX: 2,
            paddingY: 1.2,
            fontWeight: 600,
            backgroundColor: "#F97316", // Orange
            color: "white",
            "&:hover": {
              backgroundColor: "#ea6b12",
            },
          }}
        >
          + Add Query
        </Button>
      </div>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: {
            borderRadius: 12,
            padding: "10px",
          },
        }}
      >
        <div className="flex justify-between items-center px-4 py-2 border-b">
          <DialogTitle className="p-0 font-semibold text-xl tracking-wide text-orange-600">
            {isUpdate ? "Update Query" : "Create New Query"}
          </DialogTitle>

          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className="mt-4 space-y-4">
          <div className="bg-white rounded-lg border p-4 shadow-sm">
            {tagLimit && (
              <p className="text-red-500 text-sm font-medium">
                Tag length exceeded, maximum 20 characters allowed.
              </p>
            )}

            {/* TAGS + POST BUTTON */}
            <div className="flex gap-4 items-center">
              <Select
                styles={{
                  control: (provided) => ({
                    ...provided,
                    border: "none",
                    borderBottom: "2px solid #d1d5db",
                    borderRadius: 0,
                    boxShadow: "none",
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: "#9ca3af",
                  }),
                  indicatorsContainer: () => ({ display: "none" }),
                }}
                placeholder="⊕  Add Tags"
                className="w-full"
                options={clickedTopic?.length >= 3 ? [] : queryTopicList}
                isMulti
                isSearchable={true}
                value={queryTopicList?.filter((option) =>
                  clickedTopic?.includes(option?.value),
                )}
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions.map(
                    (option) => option.value,
                  );
                  setClickedTopic(selectedValues);
                }}
                onInputChange={(e) => handleInputChange(e)}
              />

              <Button
                variant="contained"
                disabled={!title}
                onClick={() => {
                  handleQueryCreation();
                  setOpenQueryDialog(false);
                }}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  paddingX: 2,
                  paddingY: 1.2,
                  fontWeight: 600,
                  backgroundColor: "#F97316", // Orange
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#ea6b12",
                  },
                }}
              >
                {isUpdate ? "Update" : "Post"}
              </Button>
            </div>

            {/* TITLE INPUT */}
            <div className="mt-4">
              <input
                placeholder="Add Title"
                className="w-full border-b p-2 focus:outline-none text-gray-800"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                maxLength={150}
              />
            </div>

            {/* DESCRIPTION + ATTACHMENT */}
            <div className="mt-4 flex items-center gap-3">
              <input
                placeholder="Type message"
                className="w-full border-b p-2 focus:outline-none text-gray-800"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                maxLength={500}
              />

              <div className="mr-2">
                <input
                  onChange={(e) => {
                    handleAttachment(e.target.files);
                    e.target.value = null;
                  }}
                  multiple
                  type="file"
                  id="attachFile"
                  accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
                  style={{ display: "none" }}
                />
                <label htmlFor="attachFile">
                  <img
                    src={assets.UploadIcon}
                    className="w-7 cursor-pointer"
                    alt="Upload"
                  />
                </label>
              </div>
            </div>

            {!isValidFileType && (
              <p className="text-red-500 mt-1 text-sm">
                Exceeded Limit! Max 5 attachments and 10 MB total size allowed.
              </p>
            )}

            {/* ATTACHMENT LIST */}
            <div className="mt-4 flex flex-wrap gap-3">
              {notesAttachmentUrl?.length > 0 &&
                notesAttachmentUrl?.map((obj, index) => (
                  <div className="flex items-center gap-2 bg-gray-100 rounded px-2 py-1">
                    <img
                      src={
                        iconData?.find(
                          (i) => i.extension === obj?.split(".")[1],
                        )?.icon
                      }
                      alt=""
                      className="w-5 h-5"
                    />

                    <span className="text-sm text-gray-700">
                      {obj?.indexOf("_") > 0
                        ? obj.substring(
                            obj.indexOf("_") + 1,
                            obj.indexOf("_") + 13,
                          ) + "..."
                        : obj.length > 15
                          ? obj.substring(0, 12) + "..."
                          : obj}
                    </span>

                    <img
                      src="/LibraryImg/CrossPdf.png"
                      alt=""
                      className="w-4 cursor-pointer"
                      onClick={() => handleremove(index)}
                    />
                  </div>
                ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <div className="LibraryFourComponentContainer">
        <Query
          book={bookName}
          chapter={chapterName}
          userDetail={userData}
          bookId={book}
          chapterId={chapter}
          grpId1={groupId}
          setEditQuery2={setEditQuery}
          setOpenQueryDialog={setOpenQueryDialog}
          setIsUpdate1={setIsUpdate}
          setComponentRerenderFlag={setComponentRerenderFlag}
          componentRerenderFlag={componentRerenderFlag}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />

        {didErrorOccur && (
          <GeneralErrorMessages
            closeWindow={() => setDidErrorOccur(false)}
            errorMessage={errorMessage}
          />
        )}
        {groupNotPresentPopUp && (
          <NoGroupPresentPopup
            setGroupNotPresentPopUp={setGroupNotPresentPopUp}
          />
        )}
        {markQuery && (
          <ResolveQueryLib
            close={() => {
              setMarkQuery(false);
            }}
            data={clickedQuery}
          />
        )}
      </div>
    </div>
  );
}
